import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getQuizResult, startQuiz } from "../../features/admin/quiz/Slice";
import "./Result_Page.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import Common_Banner from "../common/common-banner/Common_Banner";
import Full_Screen_Modal from "../full-screen-modal/Full_Screen_Modal";
import { Download_Lottie } from "../lottie/download-lottie/Download_Lottie";
import { AllQuiz } from "../../features/admin/common/Slice";
import { AllProgramList } from "../../features/admin/common/Slice";
import { IDS } from "../../utils/IDS";
import {
  ShimmerThumbnail,
  ShimmerText,
  ShimmerTitle,
} from "react-shimmer-effects";

const ShimmerResult = () => {
  return (
    <section className="Result_Page Start_Quiz">
      <Common_Banner title="Result" />

      <div className="result_card_div">
        <div className="row">
          <div className="col-lg-12">
            <ShimmerThumbnail height={500} width="100%" rounded={true} />
          </div>
        </div>
      </div>
    </section>
  );
};

const Result_Page = () => {
  const { id } = useParams(); // user_quiz_id
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeProgramId, setActiveProgramId] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const { quizResult, status } = useSelector((state) => state.quiz);
  const [showModal, setShowModal] = useState(false);
  const [isRetrying, setIsRetrying] = useState(false);

  const quizData = useSelector((state) => state.common.all_quiz || []);

  const allPrograms = useSelector(
    (state) => state.common.all_program_list || [],
  );

  // Load Result
  useEffect(() => {
    if (id) {
      dispatch(getQuizResult(id));
    }
  }, [id, dispatch]);

  const handleClaimCertificate = (e) => {
    e.preventDefault();
    if (quizResult?.certificate) {
      // const fullUrl = `http://192.168.16.58:8080/${quizResult.certificate}`;
      const fullUrl = `${IDS.IMG_URL}${quizResult.certificate}`;
      window.open(fullUrl, "_blank");
    } else {
      setShowModal(true);
      setTimeout(() => {
        setShowModal(false);
        navigate("/");
      }, 5000);
    }
  };

  // Try Again - Restart Same Quiz
  const handleTryAgain = async () => {
    if (!quizResult) return;

    setIsRetrying(true);

    try {
      const quizId = quizResult.quiz_id;

      if (!quizId) {
        alert("Cannot restart quiz. Quiz ID not found.");
        return;
      }

      const response = await dispatch(startQuiz({ quiz_id: quizId })).unwrap();
      const newUserQuizId = response?.data?.user_quiz_id;

      if (newUserQuizId) {
        navigate(`/quiz-page/${newUserQuizId}`);
      } else {
        alert("Failed to start new quiz.");
      }
    } catch (error) {
      console.error("Try Again Error:", error);
      alert(error?.message || "Failed to restart quiz");
    } finally {
      setIsRetrying(false);
    }
  };

  if (status === "loading") {
    return <ShimmerResult />;
  }

  if (status === "failed" || !quizResult) {
    return (
      <div className="text-center mt-5 text-danger">
        Failed to load result. Please try again.
      </div>
    );
  }

  const {
    user_name = "User",
    percentage = 0,
    status: resultStatus = "Fail",
    correct_answers = 0,
    total_questions = 0,
    date = "",
    questions = [],
    certificate,
  } = quizResult;

  const level =
    percentage >= 90
      ? "Expert"
      : percentage >= 75
      ? "Advanced"
      : percentage >= 60
      ? "Intermediate"
      : "Beginner";

  const recommendation =
    percentage >= 90
      ? "Excellent work! You have mastered the concepts. Keep challenging yourself with advanced projects."
      : percentage >= 75
      ? "Great job! You have strong knowledge. Focus on practical application and real-world scenarios."
      : percentage >= 60
      ? "Good effort! Review the questions you missed and strengthen those areas."
      : "Keep practicing! Review the fundamentals and attempt more quizzes to improve.";

  const isPassed = resultStatus === "Pass";

  return (
    <section className="Result_Page Start_Quiz">
      <Common_Banner title="Result" />

      <div className="result_card_div">
        <div className="row">
          <div className="col-lg-3 col-md-3 col-sm-4">
            <div className="sidebar_section">
              <div className="sidebar_group">
                <h5 className="sidebar_title">Other Quizzes</h5>
                {quizData.map((q) => (
                  <p
                    key={q.id}
                    className={`sidebar_text ${
                      activeId === q.id ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveId(q.id);
                      navigate(`/start-quiz/${q.id}`);
                    }}
                  >
                    <span>
                      <FontAwesomeIcon
                        icon={faArrowUp}
                        style={{ color: "#000" }}
                      />
                    </span>
                    {q.title}
                  </p>
                ))}
                {/* <p className="sidebar_text">
                  <span>
                    <FontAwesomeIcon
                      icon={faArrowUp}
                      style={{ color: "#000" }}
                    />
                  </span>{" "}
                  Basic Quiz For Beginners
                </p>
                <p className="sidebar_text">
                  <span>
                    <FontAwesomeIcon
                      icon={faArrowUp}
                      style={{ color: "#000" }}
                    />
                  </span>{" "}
                  If else and loops Quiz
                </p>
                <p className="sidebar_text">
                  <span>
                    <FontAwesomeIcon
                      icon={faArrowUp}
                      style={{ color: "#000" }}
                    />
                  </span>{" "}
                  Numbers Quiz
                </p>
                <p className="sidebar_text">
                  <span>
                    <FontAwesomeIcon
                      icon={faArrowUp}
                      style={{ color: "#000" }}
                    />
                  </span>{" "}
                  File Handling Quiz
                </p> */}
              </div>

              <div className="sidebar_group mt-4">
                <h5 className="sidebar_title">Our Courses</h5>
                {allPrograms.length > 0 ? (
                  allPrograms.map((program) => (
                    <p
                      key={program.id}
                      className={`sidebar_text ${
                        activeProgramId === program.id ? "active" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setActiveProgramId(program.id);
                        navigate(`/explore-program/${program.id}`);
                      }}
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={faArrowUp}
                          style={{ color: "#000" }}
                        />
                      </span>{" "}
                      {program.name}
                    </p>
                  ))
                ) : (
                  <p className="sidebar_text">No courses available.</p>
                )}
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="col-lg-8 col-md-8 col-sm-8">
            <div className="result_card">
              <div className="row">
                <div className="col-lg-8">
                  <h3 className="user_title">Hi {user_name}</h3>
                  <p className="completed">Test Completed!</p>

                  <div className="row align-items-center mt-4">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-4 text-center">
                      <div className="circle_holder">
                        <div className="score_circle">
                          <span>{percentage}%</span>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-5 col-sm-6 col-5">
                      <div className="level_holder">
                        <h5 className="level">Level {level}</h5>
                        <p className="correct_answers">
                          {correct_answers} / {total_questions} correct answers
                        </p>
                        <p className="ans_date">{date}</p>
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-3 col-sm-2 col-3">
                      <p className={`pass_text ${resultStatus.toLowerCase()}`}>
                        {resultStatus}
                      </p>
                    </div>
                  </div>

                  <hr className="divider" />

                  <div className="recommendation">
                    <h5 className="recommend_title">Recommendation</h5>
                    <p className="recommend_text">{recommendation}</p>
                  </div>
                </div>

                {/* Questions Review */}
                <div className="col-lg-4">
                  <div className="qa_card">
                    <h5 className="mb-3">Your Answers</h5>
                    {questions.map((q, index) => (
                      <div key={index} className="mb-3">
                        <p className="question">
                          Q{index + 1}. {q.question}
                        </p>
                        <p className="answer">
                          Ans : {q.user_answer || "Not answered"}
                        </p>
                        {!q.is_correct && (
                          <p className="text-danger small">
                            Correct: {q.correct_answer}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Buttons - Conditional Rendering */}
            <div className="card_btn_holder">
              {isPassed ? (
                // Only Show Download Certificate if Passed
                <button className="claim" onClick={handleClaimCertificate}>
                  Claim Certificate
                </button>
              ) : (
                // Only Show Try Again if Failed
                <button
                  className="try_again"
                  onClick={handleTryAgain}
                  disabled={isRetrying}
                >
                  {isRetrying ? "Starting New Quiz..." : "Try Again"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <Full_Screen_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Download_Lottie />}
      />
    </section>
  );
};

export default Result_Page;
